import { EventAvailable } from '@mui/icons-material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, CircularProgress, Dialog, DialogActions, DialogTitle, Tooltip, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import Skeleton from '@mui/material/Skeleton';
import { action, computed, makeObservable, observable, reaction, runInAction, when } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import ErrorUtil from '../../util/ErrorUtil';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';

class IncluirProcessosPautaLote extends ReactComponent {
    carregandoAlertas = false;
    dialogOpen = false;
    processosAlertas = [];
    carregado = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoAlertas: observable,
            dialogOpen: observable,
            processosAlertas: observable,
            carregado: observable,
            inicializarAlertas: action,
            handleClickIcone: action,
            handleCloseDialog: action,
            processos: computed,
            processosSelecionados: computed,
            limparProcessoPesquisa: action,
            mensagemLoteSemProcessos: computed,
            handleClickBotaoIncluir: action,
            incluirProcessosSelecionados: action,
            incluirProcessoEmPauta: action,
            atualizarProcessosPautaveis: action,
            carregarAlertasProcessos: action,
            renderConteudoDialog: computed
        });

        this.createReaction(
            reaction(
                () => this.dialogOpen === true,
                () => {
                    this.carregado = false;
                    this.limparProcessoPesquisa();
                    this.inicializarAlertas();
                }
            )
        );
    }

    inicializarAlertas() {
        this.carregandoAlertas = true;
        // Aguarda o carregamento das partes dos processos para verificação dos alertas
        when(
            () => this.store.carregandoPartes === false,
            () => this.carregarAlertasProcessos()
        );
    }

    handleClickIcone = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
    };

    get processos() {
        return (this.pautaJulgamentoStore.processosDisponiveisFiltrados || []).filter((registro) =>
            this.filtrarProcessoPeloNumero(registro)
        );
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get processosSelecionaveis() {
        return this.processos;
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get mensagemLoteSemProcessos() {
        return 'Não há processos pendentes para inclusão em pauta' + this.complementoMensagemFiltrando;
    }

    handleClickBotaoIncluir = async () => {
        await this.incluirProcessosSelecionados();
    };

    async incluirProcessosSelecionados() {
        await this.pautaJulgamentoStore.processarLote({
            titulo: 'Incluindo processos',
            qtdTotalProcessos: this.processosSelecionados.length,
            lotesProcessos: this.processosSelecionados,
            qtdPromisesParalelas: 1,
            funcaoOperacao: this.incluirProcessoEmPauta
        });
        let promises = [];
        promises.push(this.sessaoStore.recarregarListaProcessos());
        promises.push(this.pautaJulgamentoStore.carregarProcessosPautaveis());
        await Promise.all(promises);
    }

    incluirProcessoEmPauta = async (registro) => {
        let resultado = await this.processoService.incluirProcessoEmPautaLote(
            this.pautaJulgamentoStore.idPautaSelecionada,
            registro
        );
        this.pautaJulgamentoStore.incrementarProgressoLote();
        return resultado;
    };

    atualizarProcessosPautaveis(resultadoProcessamento) {
        this.pautaJulgamentoStore.processosPautaveis = this.pautaJulgamentoStore.processosPautaveis.filter(
            (processoPautavel) => !this.isProcessoIncluidoComSucesso(resultadoProcessamento, processoPautavel)
        );
    }

    isProcessoIncluidoComSucesso(resultadoProcessamento, processoPautavel) {
        return (
            resultadoProcessamento.findIndex((resultado) => {
                if (resultado && !ErrorUtil.isResultadoErro(resultado)) {
                    return (
                        processoPautavel &&
                        processoPautavel.processo &&
                        processoPautavel.processo.numeroCompleto &&
                        processoPautavel.processo.numeroCompleto === resultado.numeroProcesso
                    );
                }

                return false;
            }) > -1
        );
    }

    carregarAlertasProcessos() {
        if (this.dialogOpen) {
            let alertasProcessos = [];
            let alertasProcesso;
            setTimeout(() => {
                for (const registro of this.processos) {
                    alertasProcesso = this.sessaoStore.getAlertasInclusaoPautaSessao(
                        registro,
                        undefined,
                        this.pautaJulgamentoStore.pautaSelecionada.composicaoPadrao
                    );
                    if (alertasProcesso && alertasProcesso.length > 0) {
                        alertasProcessos.push({
                            numeroProcesso: registro.processo.numeroCompleto,
                            alertas: alertasProcesso.map((alerta) => ({ mensagem: alerta }))
                        });
                    }
                }
                runInAction(() => {
                    this.processosAlertas = alertasProcessos;
                    this.carregandoAlertas = false;
                    this.carregado = true;
                });
            }, 10);
        }
    }

    render() {
        if (!this.isComponenteHabilitado('IncluirProcessosPautaLote')) {
            return null;
        }
        return (
            <Fragment>
                <div
                    style={{ marginRight: '10px' }}
                    className="corBotao"
                >
                    {this.pautaJulgamentoStore.isDataSessaoPresencialFutura() ? (
                        <Tooltip
                            title={'Incluir processos em pauta em lote'}
                            placement="top-start"
                        >
                            <EventAvailable
                                style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                                onClick={this.handleClickIcone}
                            />
                        </Tooltip>
                    ) : (
                        <Tooltip
                            placement="top"
                            title="Não é possível incluir processos em pauta após início da sessão presencial"
                        >
                            <EventAvailable style={{ color: grey[300] }} />
                        </Tooltip>
                    )}
                </div>
                {this.dialogOpen && (
                    <Dialog
                        open
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        PaperProps={{ style: { height: '100%' } }}
                    >
                        {this.renderDialogTitle}
                        {this.carregado ? this.renderConteudoDialog : this.renderCarregando()}
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Fechar
                            </Button>
                            <Button
                                onClick={this.handleClickBotaoIncluir}
                                color="primary"
                                variant="outlined"
                                endIcon={<AddCircleIcon />}
                                disabled={
                                    this.carregandoAlertas ||
                                    !this.processosSelecionados ||
                                    this.processosSelecionados.length === 0
                                }
                            >
                                Incluir
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </Fragment>
        );
    }

    renderCarregando() {
        const skeleton = false;
        if (skeleton) {
            return (
                <Skeleton
                    variant="rectangular"
                    fullWidth
                    maxWidth="xl"
                    height="100%"
                    sx={{ m: 3 }}
                />
            );
        }
        return (
            <div style={{ display: 'flex', flexGrow: 1 }}>
                <CircularProgress
                    style={{ margin: '20px' }}
                    disableShrink={true}
                />
                <Typography
                    variant="h6"
                    style={{ margin: '25px 10px' }}
                >
                    Carregando processos
                </Typography>
            </div>
        );
    }

    get renderDialogTitle() {
        return (
            <DialogTitle style={{ padding: '16px 24px 0px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            flexGrow: 1
                        }}
                    >
                        <h4 style={{ margin: '0px' }}>Incluir processos em pauta em lote</h4>
                        <div style={{ margin: '0px 10px' }}>
                            <NumeroProcesso
                                dense
                                tooltip="Número do processo a ser pesquisado na listagem"
                                callbackOnChange={this.callbackNumeroProcesso}
                                clickLimpar={this.limparProcessoPesquisa}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', margin: '10px', paddingTop: '5px' }}>
                                <PainelFiltros />
                            </div>
                            <FiltroRapido id="filtroRapidoIncluirProcessosPautaLote" />
                        </div>
                    </div>
                </div>
            </DialogTitle>
        );
    }

    get renderConteudoDialog() {
        return this.carregandoAlertas ? (
            <div style={{ display: 'flex', flexGrow: 1 }}>
                <CircularProgress
                    style={{ margin: '20px' }}
                    disableShrink={true}
                />
                <Typography
                    variant="h6"
                    style={{ margin: '25px 10px' }}
                >
                    Carregando processos
                </Typography>
            </div>
        ) : (
            <Fragment>
                <OperacoesEmLoteSelecionar
                    processosSelecionaveis={this.processosSelecionaveis}
                    processos={this.processos}
                />
                <PainelProcessosOperacoesEmLote
                    processos={this.processos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    alertasProcessos={this.processosAlertas}
                />
            </Fragment>
        );
    }
}

export default inject('stores')(observer(IncluirProcessosPautaLote));
